import dateUtils from "@/utils/date";

export const listeDeCoursesAjouterPanierProps = () => ({
  liste: {
    type: Object,
    required: false,
    default: null
  }
})

export const useListeDeCoursesAjouterPanier = (props) => {
  const dateFormatted = computed(() => {
    if (props.liste.attributes.date_last_usage && props.liste.attributes.date_last_usage !== props.liste.attributes.date_creation) {
      return `Modifiée le ${dateUtils.formatDate(props.liste.attributes.date_last_usage)}`;
    } else {
      return `Créée le ${dateUtils.formatDate(props.liste.attributes.date_creation)}`;
    }
  })

  return { dateFormatted }
}